import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Actions, ofActionDispatched } from '@ngxs/store';
import { map, Observable } from 'rxjs';
import { Toast } from './core/models/common.models';
import { DisplayToast } from './core/store/states/ui/ui-state.actions';
import { ToasterComponent } from './shared/components';
import { shareRef } from './shared/operators/share-ref.operator';

@Component({
  selector: 'adspt-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss'],
  imports: [RouterOutlet, AsyncPipe, TranslatePipe, ToasterComponent],
})
export class RootComponent {
  private actions = inject(Actions);

  @Dispatch() hideToast = () => new DisplayToast({ show: false });

  readonly toast$: Observable<Partial<Toast>> = this.actions.pipe(
    ofActionDispatched(DisplayToast),
    map((action) => action.toast),
    shareRef(),
  );
}
